import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Ada = props => (
  <SvgIcon {...props} viewBox="0 0 86 86">
    <path
      id="b"
      d="m20.6 85.08 5.52-16.32h33.84l5.52 16.32h16.2l-29.88-85.08h-16.92l-29.88 85.08h15.6zm34.56-30.24h-24.24l12.12-35.88 12.12 35.88z"
    />
    <polygon
      fill="#01C1D8"
      id="a"
      points="5 85.08 20.671 85.08 52 0.08 34.997 0.08"
    />
  </SvgIcon>
);

export default Ada;
